import * as yup from 'yup';
import { valid as validateSemver } from 'semver';
import uuid4 from 'uuid4';
import { LOG_INACTIVE_PREFIX } from './constant';
var camelCase = function (key) { return yup.string().test('is-camel-case', "".concat(key, " must be in camelCase"), function (value) { return /^[a-z][A-Za-z0-9]*$/.test(value); }); };
var pascalCase = function (eventName) { return yup.string().test('is-pascal-case', "".concat(eventName, " must be in PascalCase"), function (value) { return /^[A-Z][A-Za-z0-9]*$/.test(value); }); };
var uuidv4String = function () { return yup.string().test('is-uuid-v4', 'Value must be a valid UUID v4', function (value) {
    if (value === null)
        return true; // Allow null values
    return uuid4.valid(value);
}); };
var semver = function () { return yup.string().test('is-semver', 'Value must be a valid semver', function (value) { return validateSemver(value) !== null; }); };
export var userIdSchema = uuidv4String().nullable();
export var initOptionsSchema = yup.object({
    apiKey: yup.string().required(),
    appVersion: semver().required(),
    active: yup.boolean().required(),
    verbose: yup.boolean().required(),
    apiEndpoint: yup.string().url().required(),
    appName: yup.string().trim().strict().required(),
});
export var loginOptionsSchema = yup.object({
    userId: uuidv4String().required(),
    mandantId: yup.string().uuid().required(),
    customerId: yup.string().uuid().required(),
});
export var setUserGroupOptionsSchema = yup.object({
    userGroupType: yup.string().required(),
    userGroupName: yup.mixed().required(),
});
export var setUserPropertyOptionsSchema = yup.object({
    value: yup.mixed().required(),
    key: camelCase('key').required(),
});
export var setUserPropertiesOptionsSchema = yup.object({
    userProperties: yup.object().required(),
});
export var incrementUserPropertyOptionsSchema = yup.object({
    incrementBy: yup.number().required(),
    key: camelCase('key').required(),
});
export var setUserGroupPropertyOptionsSchema = yup.object({
    value: yup.mixed().required(),
    key: camelCase('key').required(),
    groupType: yup.string().required(),
    groupName: yup.string().required(),
});
export var trackEventOptionsSchema = yup.object({
    eventName: pascalCase('eventName').required(),
    eventProperties: yup.object().default({}),
});
export var logInfoFactory = function (verbose) {
    if (verbose === void 0) { verbose = true; }
    return function (message, options) {
        if (verbose) {
            if (options && Object.keys(options).length) {
                console.info(LOG_INACTIVE_PREFIX, message, options);
            }
            else {
                console.info(LOG_INACTIVE_PREFIX, message);
            }
        }
    };
};
//# sourceMappingURL=util.js.map